import React from 'react';
import {
  secondaryServiceSubTypeQuestionId,
  serviceDeliveryQuestionId,
  serviceSubTypeQuestionId,
} from './options';

export const getActivityQuestionText = (
  questionId: number,
  programName: string,
  beneficiaryTerm: string | undefined,
  intermediaries: string | undefined,
  mainQuestionText: string | undefined,
  secondaryQuestionText: string,
): string | JSX.Element => {
  const beneficiaries =
    intermediaries?.toLowerCase() ||
    beneficiaryTerm?.toLowerCase() ||
    'beneficiaries';
  switch (questionId) {
    case serviceDeliveryQuestionId:
      return (
        <>
          How does <i>{programName}</i> deliver services to {beneficiaries}?
        </>
      );
    case serviceSubTypeQuestionId:
      return (
        <>
          How does <i>{programName}</i> primarily deliver services to{' '}
          {beneficiaries}?
        </>
      );
    case secondaryServiceSubTypeQuestionId:
      return (
        <>
          Does <i>{programName}</i> deliver services to {beneficiaries} in any
          additional way?
        </>
      );

    default:
      return mainQuestionText || secondaryQuestionText;
  }
};
